"use client";

import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, type ReactNode, useRef } from "react";
import type { IconType } from "react-icons";
import { AccordionTrigger } from "@/components/ui/accordion";
import { cx } from "@/lib/tailwind-utils";
interface Props {
  title: string;
  icon?: IconType;
  count?: number;
  action?: ReactNode;
  disabled?: boolean;
}
export function SidebarSectionHeader(t0) {
  const $ = _c(31);
  const {
    title,
    icon: Icon,
    count,
    action,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const triggerRef = useRef(null);
  const actionRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      const target = event.target;
      if (!(target instanceof Element) || !event.currentTarget.contains(target) || actionRef.current?.contains(target) || target.closest("button, a")) {
        return;
      }
      triggerRef.current?.click();
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleRowClick = t2;
  const t3 = !disabled && "cursor-pointer md:hover:bg-row-hover";
  let t4;
  if ($[1] !== t3) {
    t4 = cx("-mx-2 flex items-center rounded-md px-2 transition-colors", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Icon || $[4] !== disabled) {
    t5 = Icon && <Icon className={cx("shrink-0", disabled ? "text-foreground-muted" : "text-foreground-secondary")} />;
    $[3] = Icon;
    $[4] = disabled;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = disabled ? "text-foreground-tertiary" : "text-foreground";
  let t7;
  if ($[6] !== t6) {
    t7 = cx("min-w-0 overflow-hidden text-ellipsis text-body font-medium", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7 || $[9] !== title) {
    t8 = <span className={t7}>{title}</span>;
    $[8] = t7;
    $[9] = title;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== count || $[12] !== disabled) {
    t9 = count !== undefined && <span className={cx("shrink-0 rounded-full bg-muted px-2 py-0.5 text-caption", disabled ? "text-foreground-muted" : "text-foreground-secondary")}>{count}</span>;
    $[11] = count;
    $[12] = disabled;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className="mr-auto flex min-w-0 items-center gap-2">{t5}{t8}{t9}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== action) {
    t11 = action && <div ref={actionRef} className="shrink-0 whitespace-nowrap">{action}</div>;
    $[18] = action;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = disabled ? "cursor-not-allowed opacity-30" : "opacity-100";
  let t13;
  if ($[20] !== t12) {
    t13 = cx("ml-4 flex-grow-0 scale-75", t12);
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== disabled || $[23] !== t13 || $[24] !== title) {
    t14 = <AccordionTrigger ref={triggerRef} aria-label={title} className={t13} disabled={disabled} />;
    $[22] = disabled;
    $[23] = t13;
    $[24] = title;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t14 || $[29] !== t4) {
    t15 = <div className={t4} onClick={handleRowClick}>{t10}{t11}{t14}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t14;
    $[29] = t4;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
}